
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/card/[code]",
      function () {
        return require("private-next-pages/card/[code].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/card/[code]"])
      });
    }
  